import { create } from "zustand"

type GetStartedModalState = {
  isGetStartedModalOpen: boolean
  setIsGetStartedModalOpen: (isModalOpen: boolean) => void
}

export const useGetStartedModalStore = create<GetStartedModalState>()(
  (set) => ({
    isGetStartedModalOpen: false,
    setIsGetStartedModalOpen: (isModalOpen: boolean) =>
      set({ isGetStartedModalOpen: isModalOpen }),
  })
)
